module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "toolbar"
  }, [_c('div', {
    staticClass: "search-switch"
  }, [_c('el-button', {
    staticClass: "search-btn",
    attrs: {
      "type": "info",
      "size": "small"
    },
    on: {
      "click": _vm.toggleSearch
    }
  }, [_vm._v("高级搜索\n        "), _c('i', {
    staticClass: "el-icon--right",
    class: _vm.arrowClass
  })])], 1)]), _vm._v(" "), _c('search', {
    on: {
      "search": _vm.getQueryList
    },
    model: {
      value: (_vm.searchVisiable),
      callback: function($$v) {
        _vm.searchVisiable = $$v
      },
      expression: "searchVisiable"
    }
  }), _vm._v(" "), _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": "拼命加载中",
      "data": _vm.lists,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "StatusType",
      "label": "类型",
      "width": "150px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "OrderCode",
      "label": "订单编号",
      "width": "150px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PackageName",
      "label": "套餐名称",
      "width": "150px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ApplyTime",
      "label": "申请时间",
      "width": "170px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "SchoolName",
      "label": "幼儿园名称",
      "width": "150px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PrincipalName",
      "label": "园长",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "AgentCustomerName",
      "label": "所属代理商",
      "width": "150px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ContractStatus",
      "label": "审核状态",
      "width": "120px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "AuditOpinion",
      "label": "审核意见",
      "width": "350"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "AuditEmployeeName",
      "label": "审核人",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "AuditTime",
      "label": "订单支付时间",
      "width": "170px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "180px",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "success"
          },
          on: {
            "click": function($event) {
              _vm.view(scope.row)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary",
            "disabled": (scope.row.btnVue & 2) <= 0
          },
          on: {
            "click": function($event) {
              _vm.audit(scope.row)
            }
          }
        }, [_vm._v("审核")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.pageIndex,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalSize * 1
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('official', {
    ref: "myofficial",
    on: {
      "successcb": _vm.getList
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-91ca4644!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/school/checkSchool/checkSchool.vue
// module id = 1541
// module chunks = 1